import type { RouteLocationNormalizedLoaded } from 'vue-router'

/** Слаг кастомного модуля в `?moduleSlug=` на страницах workspace */
export function getModuleSlugFromRouteQuery(
  route: RouteLocationNormalizedLoaded,
): string | undefined {
  const q = route.query.moduleSlug
  const v = Array.isArray(q) ? q[0] : q
  if (typeof v === 'string' && v.length > 0) {
    return v
  }
  return undefined
}

/** Приоритет у query (кастомный модуль), иначе слаг из конфига подмодуля */
export function getEffectiveWorkspaceModuleSlug(
  route: RouteLocationNormalizedLoaded,
  configModuleSlug: string | undefined,
): string | undefined {
  return getModuleSlugFromRouteQuery(route) ?? configModuleSlug
}

/** Слаг глобального модуля «Дайджест новостей» для OPA / getMsNewsPermissions */
export const NEWS_DIGEST_GLOBAL_MODULE_SLUG = 'news_digest'

/** Маршруты глобального дайджеста: только `/news`, не `/entertainment` и не workspace проекта. */
export function isGlobalNewsDigestNewsRoute(
  route: Pick<RouteLocationNormalizedLoaded, 'path'>,
): boolean {
  const path = route.path.replace(/\/$/, '') || '/'
  return path === '/news' || path.startsWith('/news/')
}

/**
 * Слаг новостного модуля для загрузки backend-прав.
 * Только на `/news` без query — дайджест (`news_digest`).
 */
export function resolveNewsPermissionsModuleSlug(
  route: RouteLocationNormalizedLoaded,
  projectId: string,
): string | undefined {
  const querySlug = getModuleSlugFromRouteQuery(route)
  if (querySlug) {
    return querySlug
  }
  if (projectId) {
    return undefined
  }
  if (!isGlobalNewsDigestNewsRoute(route)) {
    return undefined
  }
  return NEWS_DIGEST_GLOBAL_MODULE_SLUG
}
